import { PartnerCampaign } from "../../models/partnerCampaign";

export class PartnerCampaignList {
  constructor(
    public readonly items: PartnerCampaign[],
    public readonly totalCount: number,
  ) {}
}
